export default {
	"logo12go": import('./logos/12go.png'),
	"logo12go_small": import('./logos/12go_small.png'),
	"logoAalease": import('./logos/aalease.png'),
	"logoAalease_small": import('./logos/aalease_small.png'),
	"logoAbarth": import('./logos/abarth.png'),
	"logoAbarth_small": import('./logos/abarth_small.png'),
	"logoAdac": import('./logos/adac.png'),
	"logoAdac_small": import('./logos/adac_small.png'),
	"logoAdriaanse": import('./logos/adriaanse.png'),
	"logoAdriaanse_small": import('./logos/adriaanse_small.png'),
	"logoAegon": import('./logos/aegon.png'),
	"logoAegon_small": import('./logos/aegon_small.png'),
	"logoAevitae": import('./logos/aevitae.png'),
	"logoAevitae_small": import('./logos/aevitae_small.png'),
	"logoAiways": import('./logos/aiways.png'),
	"logoAiways_small": import('./logos/aiways_small.png'),
	"logoAixam": import('./logos/aixam.png'),
	"logoAixam_small": import('./logos/aixam_small.png'),
	"logoAlarmcentraleeurocross": import('./logos/alarmcentraleeurocross.png'),
	"logoAlarmcentraleeurocross_small": import('./logos/alarmcentraleeurocross_small.png'),
	"logoAlbert": import('./logos/albert.png'),
	"logoAlbert_small": import('./logos/albert_small.png'),
	"logoAld": import('./logos/ald.png'),
	"logoAld_small": import('./logos/ald_small.png'),
	"logoAlfaromeo": import('./logos/alfaromeo.png'),
	"logoAlfaromeo_small": import('./logos/alfaromeo_small.png'),
	"logoAlfen": import('./logos/alfen.png'),
	"logoAlfen_small": import('./logos/alfen_small.png'),
	"logoAlphabet": import('./logos/alphabet.png'),
	"logoAlphabet_small": import('./logos/alphabet_small.png'),
	"logoAnsvar": import('./logos/ansvar.png'),
	"logoAnsvar_small": import('./logos/ansvar_small.png'),
	"logoAnwb": import('./logos/anwb.png'),
	"logoAnwbalarmcentralevoorunigarant": import('./logos/anwbalarmcentralevoorunigarant.png'),
	"logoAnwbalarmcentralevoorunigarant_small": import('./logos/anwbalarmcentralevoorunigarant_small.png'),
	"logoAnwbalarmcentralevoorzorgenzekerheid": import('./logos/anwbalarmcentralevoorzorgenzekerheid.png'),
	"logoAnwbalarmcentralevoorzorgenzekerheid_small": import('./logos/anwbalarmcentralevoorzorgenzekerheid_small.png'),
	"logoAnwbassurantien": import('./logos/anwbassurantien.png'),
	"logoAnwbassurantien_small": import('./logos/anwbassurantien_small.png'),
	"logoAnwbautoverzekering": import('./logos/anwbautoverzekering.png'),
	"logoAnwbautoverzekering_small": import('./logos/anwbautoverzekering_small.png'),
	"logoAnwbmijnpechpas": import('./logos/anwbmijnpechpas.png'),
	"logoAnwbmijnpechpas_small": import('./logos/anwbmijnpechpas_small.png'),
	"logoAnwbpersonenhulp": import('./logos/anwbpersonenhulp.png'),
	"logoAnwbpersonenhulp_small": import('./logos/anwbpersonenhulp_small.png'),
	"logoAnwbprivatelease": import('./logos/anwbprivatelease.png'),
	"logoAnwbprivatelease_small": import('./logos/anwbprivatelease_small.png'),
	"logoAnwbreisverzekering": import('./logos/anwbreisverzekering.png'),
	"logoAnwbreisverzekering_small": import('./logos/anwbreisverzekering_small.png'),
	"logoAnwbvoordezaak": import('./logos/anwbvoordezaak.png'),
	"logoAnwbvoordezaak_small": import('./logos/anwbvoordezaak_small.png'),
	"logoAnwb_small": import('./logos/anwb_small.png'),
	"logoAprilia": import('./logos/aprilia.png'),
	"logoAprilia_small": import('./logos/aprilia_small.png'),
	"logoArc": import('./logos/arc.png'),
	"logoArc_small": import('./logos/arc_small.png'),
	"logoArval": import('./logos/arval.png'),
	"logoArval_small": import('./logos/arval_small.png'),
	"logoAsmleasing": import('./logos/asmleasing.png'),
	"logoAsmleasing_small": import('./logos/asmleasing_small.png'),
	"logoAspire": import('./logos/aspire.png'),
	"logoAspire_small": import('./logos/aspire_small.png'),
	"logoAstonmartin": import('./logos/astonmartin.png'),
	"logoAstonmartin_small": import('./logos/astonmartin_small.png'),
	"logoAthlon": import('./logos/athlon.png'),
	"logoAthlon_small": import('./logos/athlon_small.png'),
	"logoAudi": import('./logos/audi.png'),
	"logoAudi_small": import('./logos/audi_small.png'),
	"logoAutoexpert": import('./logos/autoexpert.png'),
	"logoAutoexpert_small": import('./logos/autoexpert_small.png'),
	"logoAutoleasegroningen": import('./logos/autoleasegroningen.png'),
	"logoAutoleasegroningen_small": import('./logos/autoleasegroningen_small.png'),
	"logoAutopautoverhuur": import('./logos/autopautoverhuur.png'),
	"logoAutopautoverhuur_small": import('./logos/autopautoverhuur_small.png'),
	"logoAutorent": import('./logos/autorent.png'),
	"logoAutorent_small": import('./logos/autorent_small.png'),
	"logoAutoverhuurbultman": import('./logos/autoverhuurbultman.png'),
	"logoAutoverhuurbultman_small": import('./logos/autoverhuurbultman_small.png'),
	"logoAveco": import('./logos/aveco.png'),
	"logoAveco_small": import('./logos/aveco_small.png'),
	"logoAvisbudget": import('./logos/avisbudget.png'),
	"logoAvisbudget_small": import('./logos/avisbudget_small.png'),
	"logoBabboe": import('./logos/babboe.png'),
	"logoBabboe_small": import('./logos/babboe_small.png'),
	"logoBatavus": import('./logos/batavus.png'),
	"logoBatavus_small": import('./logos/batavus_small.png'),
	"logoBedrijfswagenleasing": import('./logos/bedrijfswagenleasing.png'),
	"logoBedrijfswagenleasing_small": import('./logos/bedrijfswagenleasing_small.png'),
	"logoBenelli": import('./logos/benelli.png'),
	"logoBenelli_small": import('./logos/benelli_small.png'),
	"logoBentley": import('./logos/bentley.png'),
	"logoBentley_small": import('./logos/bentley_small.png'),
	"logoBertjonk": import('./logos/bertjonk.png'),
	"logoBertjonk_small": import('./logos/bertjonk_small.png'),
	"logoBewuzt": import('./logos/bewuzt.png'),
	"logoBewuzt_small": import('./logos/bewuzt_small.png'),
	"logoBfp": import('./logos/bfp.png'),
	"logoBfp_small": import('./logos/bfp_small.png'),
	"logoBimota": import('./logos/bimota.png'),
	"logoBimota_small": import('./logos/bimota_small.png'),
	"logoBluekens": import('./logos/bluekens.png'),
	"logoBluekens_small": import('./logos/bluekens_small.png'),
	"logoBmw": import('./logos/bmw.png'),
	"logoBmw_small": import('./logos/bmw_small.png'),
	"logoBorent": import('./logos/borent.png'),
	"logoBorent_small": import('./logos/borent_small.png'),
	"logoBosch": import('./logos/bosch.png'),
	"logoBosch_small": import('./logos/bosch_small.png'),
	"logoBotenwacht": import('./logos/botenwacht.png'),
	"logoBotenwacht_small": import('./logos/botenwacht_small.png'),
	"logoBourguignon": import('./logos/bourguignon.png'),
	"logoBourguignon_small": import('./logos/bourguignon_small.png'),
	"logoBreedveld": import('./logos/breedveld.png'),
	"logoBreedveld_small": import('./logos/breedveld_small.png'),
	"logoBreijer": import('./logos/breijer.png'),
	"logoBreijer_small": import('./logos/breijer_small.png'),
	"logoBrightlease": import('./logos/brightlease.png'),
	"logoBrightlease_small": import('./logos/brightlease_small.png'),
	"logoBuell": import('./logos/buell.png'),
	"logoBuell_small": import('./logos/buell_small.png'),
	"logoBuitenlandsebezoekercoma": import('./logos/buitenlandsebezoekercoma.png'),
	"logoBuitenlandsebezoekercoma_small": import('./logos/buitenlandsebezoekercoma_small.png'),
	"logoBuitenlandsebezoekerzama": import('./logos/buitenlandsebezoekerzama.png'),
	"logoBuitenlandsebezoekerzama_small": import('./logos/buitenlandsebezoekerzama_small.png'),
	"logoBuroscanbrit": import('./logos/buroscanbrit.png'),
	"logoBuroscanbrit_small": import('./logos/buroscanbrit_small.png'),
	"logoBusinesslease": import('./logos/businesslease.png'),
	"logoBusinesslease_small": import('./logos/businesslease_small.png'),
	"logoCacemergency": import('./logos/cacemergency.png'),
	"logoCacemergency_small": import('./logos/cacemergency_small.png'),
	"logoCadillac": import('./logos/cadillac.png'),
	"logoCadillac_small": import('./logos/cadillac_small.png'),
	"logoCagiva": import('./logos/cagiva.png'),
	"logoCagiva_small": import('./logos/cagiva_small.png'),
	"logoCarver": import('./logos/carver.png'),
	"logoCarver_small": import('./logos/carver_small.png'),
	"logoCentaur": import('./logos/centaur.png'),
	"logoCentaur_small": import('./logos/centaur_small.png'),
	"logoChevrolet": import('./logos/chevrolet.png'),
	"logoChevrolet_small": import('./logos/chevrolet_small.png'),
	"logoChrysler": import('./logos/chrysler.png'),
	"logoChrysler_small": import('./logos/chrysler_small.png'),
	"logoCitroen": import('./logos/citroen.png'),
	"logoCitroen_small": import('./logos/citroen_small.png'),
	"logoConnectbike": import('./logos/connectbike.png'),
	"logoConnectbike_small": import('./logos/connectbike_small.png'),
	"logoConnexxion": import('./logos/connexxion.png'),
	"logoConnexxion_small": import('./logos/connexxion_small.png'),
	"logoCorona2020": import('./logos/corona2020.png'),
	"logoCorona2020_small": import('./logos/corona2020_small.png'),
	"logoCorvette": import('./logos/corvette.png'),
	"logoCorvette_small": import('./logos/corvette_small.png'),
	"logoCupra": import('./logos/cupra.png'),
	"logoCupra_small": import('./logos/cupra_small.png'),
	"logoDacia": import('./logos/dacia.png'),
	"logoDacia_small": import('./logos/dacia_small.png'),
	"logoDaewoo": import('./logos/daewoo.png'),
	"logoDaewoo_small": import('./logos/daewoo_small.png'),
	"logoDaihatsu": import('./logos/daihatsu.png'),
	"logoDaihatsu_small": import('./logos/daihatsu_small.png'),
	"logoDaimler": import('./logos/daimler.png'),
	"logoDaimler_small": import('./logos/daimler_small.png'),
	"logoDealerlabellease": import('./logos/dealerlabellease.png'),
	"logoDealerlabellease_small": import('./logos/dealerlabellease_small.png'),
	"logoDealerleasing": import('./logos/dealerleasing.png'),
	"logoDealerleasing_small": import('./logos/dealerleasing_small.png'),
	"logoDecathlon": import('./logos/decathlon.png'),
	"logoDecathlon_small": import('./logos/decathlon_small.png'),
	"logoDegarage": import('./logos/degarage.png'),
	"logoDegarage_small": import('./logos/degarage_small.png'),
	"logoDirectlease": import('./logos/directlease.png'),
	"logoDirectlease_small": import('./logos/directlease_small.png'),
	"logoDockr": import('./logos/dockr.png'),
	"logoDockr_small": import('./logos/dockr_small.png'),
	"logoDodge": import('./logos/dodge.png'),
	"logoDodge_small": import('./logos/dodge_small.png'),
	"logoDs": import('./logos/ds.png'),
	"logoDs_small": import('./logos/ds_small.png'),
	"logoDucati": import('./logos/ducati.png'),
	"logoDucati_small": import('./logos/ducati_small.png'),
	"logoDuravermeer": import('./logos/duravermeer.png'),
	"logoDuravermeer_small": import('./logos/duravermeer_small.png'),
	"logoDutchlease": import('./logos/dutchlease.png'),
	"logoDutchlease_small": import('./logos/dutchlease_small.png'),
	"logoElectricfreeway": import('./logos/electricfreeway.png'),
	"logoElectricfreeway_small": import('./logos/electricfreeway_small.png'),
	"logoEnexis": import('./logos/enexis.png'),
	"logoEnexis_small": import('./logos/enexis_small.png'),
	"logoEnterprise": import('./logos/enterprise.png'),
	"logoEnterprise_small": import('./logos/enterprise_small.png'),
	"logoErnstyoung": import('./logos/ernstyoung.png'),
	"logoErnstyoung_small": import('./logos/ernstyoung_small.png'),
	"logoEswe": import('./logos/eswe.png'),
	"logoEswe_small": import('./logos/eswe_small.png'),
	"logoEurocover": import('./logos/eurocover.png'),
	"logoEurocover_small": import('./logos/eurocover_small.png'),
	"logoEurocross": import('./logos/eurocross.png'),
	"logoEurocross_small": import('./logos/eurocross_small.png'),
	"logoEuroinsurances": import('./logos/euroinsurances.png'),
	"logoEuroinsurances_small": import('./logos/euroinsurances_small.png'),
	"logoEuromobil": import('./logos/euromobil.png'),
	"logoEuromobil_small": import('./logos/euromobil_small.png'),
	"logoEuropcar": import('./logos/europcar.png'),
	"logoEuropcar_small": import('./logos/europcar_small.png'),
	"logoEurowheelz": import('./logos/eurowheelz.png'),
	"logoEurowheelz_small": import('./logos/eurowheelz_small.png'),
	"logoEvbox": import('./logos/evbox.png'),
	"logoEvbox_small": import('./logos/evbox_small.png'),
	"logoEvnet": import('./logos/evnet.png'),
	"logoEvnet_small": import('./logos/evnet_small.png'),
	"logoFacilicom": import('./logos/facilicom.png'),
	"logoFacilicom_small": import('./logos/facilicom_small.png'),
	"logoFcacapital": import('./logos/fcacapital.png'),
	"logoFcacapital_small": import('./logos/fcacapital_small.png'),
	"logoFerrari": import('./logos/ferrari.png'),
	"logoFerrari_small": import('./logos/ferrari_small.png'),
	"logoFiat": import('./logos/fiat.png'),
	"logoFiat_small": import('./logos/fiat_small.png'),
	"logoFietservicenederland_small": import('./logos/fietservicenederland_small.png'),
	"logoFietsnet": import('./logos/fietsnet.png'),
	"logoFietsnet_small": import('./logos/fietsnet_small.png'),
	"logoFietsservicenederland": import('./logos/fietsservicenederland.png'),
	"logoFlr": import('./logos/flr.png'),
	"logoFlr_small": import('./logos/flr_small.png'),
	"logoFord": import('./logos/ford.png'),
	"logoFord_small": import('./logos/ford_small.png'),
	"logoFox": import('./logos/fox.png'),
	"logoFox_small": import('./logos/fox_small.png'),
	"logoFriesland": import('./logos/friesland.png'),
	"logoFriesland_small": import('./logos/friesland_small.png'),
	"logoGasunie": import('./logos/gasunie.png'),
	"logoGasunie_small": import('./logos/gasunie_small.png'),
	"logoGazelle": import('./logos/gazelle.png'),
	"logoGazelle_small": import('./logos/gazelle_small.png'),
	"logoGemeentezoetermeer": import('./logos/gemeentezoetermeer.png'),
	"logoGemeentezoetermeer_small": import('./logos/gemeentezoetermeer_small.png'),
	"logoGetbikeservice": import('./logos/getbikeservice.png'),
	"logoGetbikeservice_small": import('./logos/getbikeservice_small.png'),
	"logoGoudse": import('./logos/goudse.png'),
	"logoGoudse_small": import('./logos/goudse_small.png'),
	"logoGreenflux": import('./logos/greenflux.png'),
	"logoGreenflux_small": import('./logos/greenflux_small.png'),
	"logoGreenwheels": import('./logos/greenwheels.png'),
	"logoGreenwheels_small": import('./logos/greenwheels_small.png'),
	"logoH4": import('./logos/h4.png'),
	"logoH4_small": import('./logos/h4_small.png'),
	"logoHarley": import('./logos/harley.png'),
	"logoHarley_small": import('./logos/harley_small.png'),
	"logoHellorider": import('./logos/hellorider.png'),
	"logoHellorider_small": import('./logos/hellorider_small.png'),
	"logoHema": import('./logos/hema.png'),
	"logoHema_small": import('./logos/hema_small.png'),
	"logoHertz": import('./logos/hertz.png'),
	"logoHertz_small": import('./logos/hertz_small.png'),
	"logoHienfeld": import('./logos/hienfeld.png'),
	"logoHienfeld_small": import('./logos/hienfeld_small.png'),
	"logoHitachi": import('./logos/hitachi.png'),
	"logoHitachi_small": import('./logos/hitachi_small.png'),
	"logoHonda": import('./logos/honda.png'),
	"logoHonda_small": import('./logos/honda_small.png'),
	"logoHoppenbrouwers": import('./logos/hoppenbrouwers.png'),
	"logoHoppenbrouwers_small": import('./logos/hoppenbrouwers_small.png'),
	"logoHuiskes": import('./logos/huiskes.png'),
	"logoHuiskes_small": import('./logos/huiskes_small.png'),
	"logoHummer": import('./logos/hummer.png'),
	"logoHummer_small": import('./logos/hummer_small.png'),
	"logoHusqvarna": import('./logos/husqvarna.png'),
	"logoHusqvarna_small": import('./logos/husqvarna_small.png'),
	"logoHyundai": import('./logos/hyundai.png'),
	"logoHyundai_small": import('./logos/hyundai_small.png'),
	"logoIng": import('./logos/ing.png'),
	"logoIng_small": import('./logos/ing_small.png'),
	"logoInqar": import('./logos/inqar.png'),
	"logoInqar_small": import('./logos/inqar_small.png'),
	"logoIsuzu": import('./logos/isuzu.png'),
	"logoIsuzu_small": import('./logos/isuzu_small.png'),
	"logoIveco": import('./logos/iveco.png'),
	"logoIveco_small": import('./logos/iveco_small.png'),
	"logoIza": import('./logos/iza.png'),
	"logoIza_small": import('./logos/iza_small.png'),
	"logoIzibike": import('./logos/izibike.png'),
	"logoIzibike_small": import('./logos/izibike_small.png'),
	"logoIzz": import('./logos/izz.png'),
	"logoIzz_small": import('./logos/izz_small.png'),
	"logoJaguar": import('./logos/jaguar.png'),
	"logoJaguar_small": import('./logos/jaguar_small.png'),
	"logoJawa": import('./logos/jawa.png'),
	"logoJawa_small": import('./logos/jawa_small.png'),
	"logoJeep": import('./logos/jeep.png'),
	"logoJeep_small": import('./logos/jeep_small.png'),
	"logoJlr": import('./logos/jlr.png'),
	"logoJlr_small": import('./logos/jlr_small.png'),
	"logoJohnnyloco": import('./logos/johnnyloco.png'),
	"logoJohnnyloco_small": import('./logos/johnnyloco_small.png'),
	"logoJtautolease": import('./logos/jtautolease.png'),
	"logoJtautolease_small": import('./logos/jtautolease_small.png'),
	"logoJuizz": import('./logos/juizz.png'),
	"logoJuizz_small": import('./logos/juizz_small.png'),
	"logoKawasaki": import('./logos/kawasaki.png'),
	"logoKawasaki_small": import('./logos/kawasaki_small.png'),
	"logoKia": import('./logos/kia.png'),
	"logoKia_small": import('./logos/kia_small.png'),
	"logoKnac": import('./logos/knac.png'),
	"logoKnac_small": import('./logos/knac_small.png'),
	"logoKnmv": import('./logos/knmv.png'),
	"logoKnmv_small": import('./logos/knmv_small.png'),
	"logoKnrm": import('./logos/knrm.png'),
	"logoKnrm_small": import('./logos/knrm_small.png'),
	"logoKoga": import('./logos/koga.png'),
	"logoKoga_small": import('./logos/koga_small.png'),
	"logoKpn": import('./logos/kpn.png'),
	"logoKpn_small": import('./logos/kpn_small.png'),
	"logoKtm": import('./logos/ktm.png'),
	"logoKtm_small": import('./logos/ktm_small.png'),
	"logoKuperus": import('./logos/kuperus.png'),
	"logoKuperus_small": import('./logos/kuperus_small.png'),
	"logoKymco": import('./logos/kymco.png'),
	"logoKymco_small": import('./logos/kymco_small.png'),
	"logoKyotolease": import('./logos/kyotolease.png'),
	"logoKyotolease_small": import('./logos/kyotolease_small.png'),
	"logoLada": import('./logos/lada.png'),
	"logoLada_small": import('./logos/lada_small.png'),
	"logoLamborghini": import('./logos/lamborghini.png'),
	"logoLamborghini_small": import('./logos/lamborghini_small.png'),
	"logoLancia": import('./logos/lancia.png'),
	"logoLancia_small": import('./logos/lancia_small.png'),
	"logoLandrover": import('./logos/landrover.png'),
	"logoLandrover_small": import('./logos/landrover_small.png'),
	"logoLeaseabike": import('./logos/leaseabike.png'),
	"logoLeaseabike_small": import('./logos/leaseabike_small.png'),
	"logoLeaseconnection": import('./logos/leaseconnection.png'),
	"logoLeaseconnection_small": import('./logos/leaseconnection_small.png'),
	"logoLeaseplan": import('./logos/leaseplan.png'),
	"logoLeaseplan_small": import('./logos/leaseplan_small.png'),
	"logoLeasequality": import('./logos/leasequality.png'),
	"logoLeasequality_small": import('./logos/leasequality_small.png'),
	"logoLeasevisie": import('./logos/leasevisie.png'),
	"logoLeasys": import('./logos/leasys.png'),
	"logoLeasys_small": import('./logos/leasys_small.png'),
	"logoLexus": import('./logos/lexus.png'),
	"logoLexus_small": import('./logos/lexus_small.png'),
	"logoLigier": import('./logos/ligier.png'),
	"logoLigier_small": import('./logos/ligier_small.png'),
	"logoLogicx": import('./logos/logicx.png'),
	"logoLogicx_small": import('./logos/logicx_small.png'),
	"logoLynkco": import('./logos/lynkco.png'),
	"logoLynkco_small": import('./logos/lynkco_small.png'),
	"logoMaarten": import('./logos/maarten.png'),
	"logoMaarten_small": import('./logos/maarten_small.png'),
	"logoMaasleasing": import('./logos/maasleasing.png'),
	"logoMaasleasing_small": import('./logos/maasleasing_small.png'),
	"logoMango": import('./logos/mango.png'),
	"logoMango_small": import('./logos/mango_small.png'),
	"logoMantel": import('./logos/mantel.png'),
	"logoMantel_small": import('./logos/mantel_small.png'),
	"logoMazda": import('./logos/mazda.png'),
	"logoMazda_small": import('./logos/mazda_small.png'),
	"logoMclaren": import('./logos/mclaren.png'),
	"logoMclaren_small": import('./logos/mclaren_small.png'),
	"logoMdekoning": import('./logos/mdekoning.png'),
	"logoMdekoning_small": import('./logos/mdekoning_small.png'),
	"logoMenzis": import('./logos/menzis.png'),
	"logoMenzis_small": import('./logos/menzis_small.png'),
	"logoMercedesbenz": import('./logos/mercedesbenz.png'),
	"logoMercedesbenz_small": import('./logos/mercedesbenz_small.png'),
	"logoMg": import('./logos/mg.png'),
	"logoMg_small": import('./logos/mg_small.png'),
	"logoMini": import('./logos/mini.png'),
	"logoMini_small": import('./logos/mini_small.png'),
	"logoMistergreen": import('./logos/mistergreen.png'),
	"logoMistergreen_small": import('./logos/mistergreen_small.png'),
	"logoMitsubishi": import('./logos/mitsubishi.png'),
	"logoMitsubishi_small": import('./logos/mitsubishi_small.png'),
	"logoMolenaar": import('./logos/molenaar.png'),
	"logoMolenaar_small": import('./logos/molenaar_small.png'),
	"logoMopar": import('./logos/mopar.png'),
	"logoMopar_small": import('./logos/mopar_small.png'),
	"logoMorgan": import('./logos/morgan.png'),
	"logoMorgan_small": import('./logos/morgan_small.png'),
	"logoMotoguzzi": import('./logos/motoguzzi.png'),
	"logoMotoguzzi_small": import('./logos/motoguzzi_small.png'),
	"logoMotoshare": import('./logos/motoshare.png'),
	"logoMotoshare_small": import('./logos/motoshare_small.png'),
	"logoMourik": import('./logos/mourik.png'),
	"logoMourik_small": import('./logos/mourik_small.png'),
	"logoMultitankcard": import('./logos/multitankcard.png'),
	"logoMultitankcard_small": import('./logos/multitankcard_small.png'),
	"logoMunsterhuis": import('./logos/munsterhuis.png'),
	"logoMunsterhuis_small": import('./logos/munsterhuis_small.png'),
	"logoNamallianz": import('./logos/namallianz.png'),
	"logoNamallianz_small": import('./logos/namallianz_small.png'),
	"logoNameurocross": import('./logos/nameurocross.png'),
	"logoNameurocross_small": import('./logos/nameurocross_small.png'),
	"logoNamipa": import('./logos/namipa.png'),
	"logoNamipa_small": import('./logos/namipa_small.png'),
	"logoNamsosinternational": import('./logos/namsosinternational.png'),
	"logoNamsosinternational_small": import('./logos/namsosinternational_small.png'),
	"logoNamvhd": import('./logos/namvhd.png'),
	"logoNamvhd_small": import('./logos/namvhd_small.png'),
	"logoNationalenederlanden": import('./logos/nationalenederlanden.png'),
	"logoNationalenederlanden_small": import('./logos/nationalenederlanden_small.png'),
	"logoNedasco": import('./logos/nedasco.png'),
	"logoNedasco_small": import('./logos/nedasco_small.png'),
	"logoNissan": import('./logos/nissan.png'),
	"logoNissan_small": import('./logos/nissan_small.png'),
	"logoNkbv": import('./logos/nkbv.png'),
	"logoNkbv_small": import('./logos/nkbv_small.png'),
	"logoNoaccess": import('./logos/noaccess.png'),
	"logoNoaccess_small": import('./logos/noaccess_small.png'),
	"logoNovox": import('./logos/novox.png'),
	"logoNovox_small": import('./logos/novox_small.png'),
	"logoOnthemove": import('./logos/onthemove.png'),
	"logoOnthemove_small": import('./logos/onthemove_small.png'),
	"logoOnvz": import('./logos/onvz.png'),
	"logoOnvz_small": import('./logos/onvz_small.png'),
	"logoOpel": import('./logos/opel.png'),
	"logoOpel_small": import('./logos/opel_small.png'),
	"logoOscar": import('./logos/oscar.png'),
	"logoOscar_small": import('./logos/oscar_small.png'),
	"logoOtolift": import('./logos/otolift.png'),
	"logoOtolift_small": import('./logos/otolift_small.png'),
	"logoOvz": import('./logos/ovz.png'),
	"logoOvz_small": import('./logos/ovz_small.png'),
	"logoPaknbak": import('./logos/paknbak.png'),
	"logoPaknbak_small": import('./logos/paknbak_small.png'),
	"logoParkflyrent": import('./logos/parkflyrent.png'),
	"logoParkflyrent_small": import('./logos/parkflyrent_small.png'),
	"logoPeugeot": import('./logos/peugeot.png'),
	"logoPeugeot_small": import('./logos/peugeot_small.png'),
	"logoPharos": import('./logos/pharos.png'),
	"logoPharos_small": import('./logos/pharos_small.png'),
	"logoPiaggio": import('./logos/piaggio.png'),
	"logoPiaggio_small": import('./logos/piaggio_small.png'),
	"logoPitpoint": import('./logos/pitpoint.png'),
	"logoPitpoint_small": import('./logos/pitpoint_small.png'),
	"logoPno": import('./logos/pno.png'),
	"logoPno_small": import('./logos/pno_small.png'),
	"logoPolestar": import('./logos/polestar.png'),
	"logoPolestar_small": import('./logos/polestar_small.png'),
	"logoPolitie": import('./logos/politie.png'),
	"logoPolitie_small": import('./logos/politie_small.png'),
	"logoPorsche": import('./logos/porsche.png'),
	"logoPorsche_small": import('./logos/porsche_small.png'),
	"logoPostnl": import('./logos/postnl.png'),
	"logoPostnl_small": import('./logos/postnl_small.png'),
	"logoProfilease": import('./logos/profilease.png'),
	"logoProfilease_small": import('./logos/profilease_small.png'),
	"logoPsa": import('./logos/psa.png'),
	"logoPsa_small": import('./logos/psa_small.png'),
	"logoQuingo": import('./logos/quingo.png'),
	"logoQuingo_small": import('./logos/quingo_small.png'),
	"logoRangerover": import('./logos/rangerover.png'),
	"logoRangerover_small": import('./logos/rangerover_small.png'),
	"logoRenault": import('./logos/renault.png'),
	"logoRenault_small": import('./logos/renault_small.png'),
	"logoRollsroyce": import('./logos/rollsroyce.png'),
	"logoRollsroyce_small": import('./logos/rollsroyce_small.png'),
	"logoSaab": import('./logos/saab.png'),
	"logoSaab_small": import('./logos/saab_small.png'),
	"logoSaintgobain": import('./logos/saintgobain.png'),
	"logoSaintgobain_small": import('./logos/saintgobain_small.png'),
	"logoSeat": import('./logos/seat.png'),
	"logoSeat_small": import('./logos/seat_small.png'),
	"logoShortlease": import('./logos/shortlease.png'),
	"logoShortleaseland": import('./logos/shortleaseland.png'),
	"logoShortleaseland_small": import('./logos/shortleaseland_small.png'),
	"logoShortlease_small": import('./logos/shortlease_small.png'),
	"logoSixt": import('./logos/sixt.png'),
	"logoSixt_small": import('./logos/sixt_small.png'),
	"logoSkoda": import('./logos/skoda.png'),
	"logoSkoda_small": import('./logos/skoda_small.png'),
	"logoSmart": import('./logos/smart.png'),
	"logoSmart_small": import('./logos/smart_small.png'),
	"logoSnappcar": import('./logos/snappcar.png'),
	"logoSnappcar_small": import('./logos/snappcar_small.png'),
	"logoSnp": import('./logos/snp.png'),
	"logoSnp_small": import('./logos/snp_small.png'),
	"logoSparta": import('./logos/sparta.png'),
	"logoSparta_small": import('./logos/sparta_small.png'),
	"logoSpoticar": import('./logos/spoticar.png'),
	"logoSpoticar_small": import('./logos/spoticar_small.png'),
	"logoSsangyong": import('./logos/ssangyong.png'),
	"logoSsangyong_small": import('./logos/ssangyong_small.png'),
	"logoStern": import('./logos/stern.png'),
	"logoStern_small": import('./logos/stern_small.png'),
	"logoSubaru": import('./logos/subaru.png'),
	"logoSubaru_small": import('./logos/subaru_small.png'),
	"logoSuzuki": import('./logos/suzuki.png'),
	"logoSuzuki_small": import('./logos/suzuki_small.png'),
	"logoSym": import('./logos/sym.png'),
	"logoSym_small": import('./logos/sym_small.png'),
	"logoSzvk": import('./logos/szvk.png'),
	"logoSzvk_small": import('./logos/szvk_small.png'),
	"logoTesla": import('./logos/tesla.png'),
	"logoTesla_small": import('./logos/tesla_small.png'),
	"logoTomos": import('./logos/tomos.png'),
	"logoTomos_small": import('./logos/tomos_small.png'),
	"logoTotal": import('./logos/total.png'),
	"logoTotal_small": import('./logos/total_small.png'),
	"logoToyota": import('./logos/toyota.png'),
	"logoToyota_small": import('./logos/toyota_small.png'),
	"logoTravelcare": import('./logos/travelcare.png'),
	"logoTravelcare_small": import('./logos/travelcare_small.png'),
	"logoTravelhome": import('./logos/travelhome.png'),
	"logoTravelhome_small": import('./logos/travelhome_small.png'),
	"logoTriumph": import('./logos/triumph.png'),
	"logoTriumph_small": import('./logos/triumph_small.png'),
	"logoUmc": import('./logos/umc.png'),
	"logoUmc_small": import('./logos/umc_small.png'),
	"logoUnigarant": import('./logos/unigarant.png'),
	"logoUnigarant_small": import('./logos/unigarant_small.png'),
	"logoUnive": import('./logos/unive.png'),
	"logoUnive_small": import('./logos/unive_small.png'),
	"logoUrbee": import('./logos/urbee.png'),
	"logoUrbee_small": import('./logos/urbee_small.png'),
	"logoUwlogo": import('./logos/uwlogo.png'),
	"logoVandusschoten": import('./logos/vandusschoten.png'),
	"logoVandusschoten_small": import('./logos/vandusschoten_small.png'),
	"logoVangent": import('./logos/vangent.png'),
	"logoVangent_small": import('./logos/vangent_small.png'),
	"logoVanmossel": import('./logos/vanmossel.png'),
	"logoVanmossel_small": import('./logos/vanmossel_small.png'),
	"logoVanthart": import('./logos/vanthart.png'),
	"logoVanthart_small": import('./logos/vanthart_small.png'),
	"logoVattenfall": import('./logos/vattenfall.png'),
	"logoVattenfall_small": import('./logos/vattenfall_small.png'),
	"logoVervoermaterieel": import('./logos/vervoermaterieel.png'),
	"logoVervoermaterieel_small": import('./logos/vervoermaterieel_small.png'),
	"logoVgz": import('./logos/vgz.png'),
	"logoVgz_small": import('./logos/vgz_small.png'),
	"logoVlc": import('./logos/vlc.png'),
	"logoVlc_small": import('./logos/vlc_small.png'),
	"logoVmleasing": import('./logos/vmleasing.png'),
	"logoVmleasing_small": import('./logos/vmleasing_small.png'),
	"logoVolkerstevin": import('./logos/volkerstevin.png'),
	"logoVolkerstevin_small": import('./logos/volkerstevin_small.png'),
	"logoVolkswagen": import('./logos/volkswagen.png'),
	"logoVolkswagenleasing": import('./logos/volkswagenleasing.png'),
	"logoVolkswagenleasing_small": import('./logos/volkswagenleasing_small.png'),
	"logoVolkswagen_small": import('./logos/volkswagen_small.png'),
	"logoVolvo": import('./logos/volvo.png'),
	"logoVolvocarlease": import('./logos/volvocarlease.png'),
	"logoVolvocarlease_small": import('./logos/volvocarlease_small.png'),
	"logoVolvo_small": import('./logos/volvo_small.png'),
	"logoVpz": import('./logos/vpz.png'),
	"logoVpz_small": import('./logos/vpz_small.png'),
	"logoWaaijenberg": import('./logos/waaijenberg.png'),
	"logoWaaijenberg_small": import('./logos/waaijenberg_small.png'),
	"logoWelzorg": import('./logos/welzorg.png'),
	"logoWelzorg_small": import('./logos/welzorg_small.png'),
	"logoWensink": import('./logos/wensink.png'),
	"logoWensink_small": import('./logos/wensink_small.png'),
	"logoWevi": import('./logos/wevi.png'),
	"logoWevi_small": import('./logos/wevi_small.png'),
	"logoWwvoertuigen": import('./logos/wwvoertuigen.png'),
	"logoWwvoertuigen_small": import('./logos/wwvoertuigen_small.png'),
	"logoXllease": import('./logos/xllease.png'),
	"logoXllease_small": import('./logos/xllease_small.png'),
	"logoYamaha": import('./logos/yamaha.png'),
	"logoYamaha_small": import('./logos/yamaha_small.png'),
	"logoZeeuwse": import('./logos/zeeuwse.png'),
	"logoZeeuwse_small": import('./logos/zeeuwse_small.png'),
	"logoZekur": import('./logos/zekur.png'),
	"logoZekur_small": import('./logos/zekur_small.png'),
	"logoZlm": import('./logos/zlm.png'),
	"logoZlm_small": import('./logos/zlm_small.png'),
	"logoZorgenzekerheid": import('./logos/zorgenzekerheid.png'),
	"logoZorgenzekerheid_small": import('./logos/zorgenzekerheid_small.png'),
	"logoZorgzaam": import('./logos/zorgzaam.png'),
	"logoZorgzaam_small": import('./logos/zorgzaam_small.png'),
	"logoZuidwestlease": import('./logos/zuidwestlease.png'),
	"logoZuidwestlease_small": import('./logos/zuidwestlease_small.png'),
}